module.exports = __webpack_public_path__ + "img/join-img.b33903a7.svg";